import React, { useCallback, useEffect, useRef, useState } from "react";
import {
  Avatar,
  Box,
  Modal,
  Typography,
  IconButton,
  TextField,
  Button,
  useMediaQuery,
  Stack,
  Tooltip,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ChatBubbleOutlineOutlinedIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import AddPhotoAlternateOutlinedIcon from "@mui/icons-material/AddPhotoAlternateOutlined";
import logo from "../../assets/images/bf.jpg";
import CustomPopover from "./CustomPopOver";
import { EmojiEmotions, MoreVertOutlined } from "@mui/icons-material";
import { Icon } from "@iconify/react";
import CustomConfirmation from "./CustomConfirmation";
import { enqueueSnackbar, useSnackbar } from "notistack";
import ThumbUpAltOutlinedIcon from "@mui/icons-material/ThumbUpAltOutlined";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ImageGallery from "react-image-gallery";
import EmojiPicker from "emoji-picker-react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import moment from "moment";
import { htmlDecode, is_small_screen } from "../../utils/Constant";
import CreatePost from "../../pages/post/CreatePost";
import ReactVideoPlayer from "../player/ReactVideoPlayer";
import { useIds } from "../../hook/AdminContext";
import { s3baseUri } from "../../config/config";
import FeedImageSlider from "../cards/FeedImageSlider";
import ShareIcon from "@mui/icons-material/Share";
import {
  detail_feed_api,
  get_feeds_detail_api,
} from "../../DAL/partner/partners";
import {
  csvImage,
  docImage,
  pdfImage,
  wordImage,
  audioImage,
  xlsxImage,
  otherImage,
} from "../../assets";
import PreviewPostCard from "../previewUrl/LinkPreviewPostCard";
import { useNavigate } from "react-router-dom";
import {
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaTwitter,
  FaYoutube,
} from "react-icons/fa";
import Divider from "@mui/material/Divider";
import RecordNoImage from "../recordNotFound/RecordNoImage";

const PostDetailPopup = ({
  parseDescriptionWithLink,
  linkInDescription,
  setLiked,
  likedComment,
  handleLikeComment,
  open,
  handleMenu,
  handleLike,
  liked,
  onClose,
  post,
  comments,
  likeCount,
  handleMenucomments,
  isLoadingCom,
  setEmojiPickerVisible,
  emojiPickerVisible,
  setComment,
  setComments,
  comment,
  handleEmojiClick,
  handleImageUpload,
  setPreview,
  preview,
  commentText,
  setCommentText,
  handleCommentSubmit,
  setIsEditing,
  isEditing,
  selectedImageIndex,
  commentCount,
  commentsLikeCount,
  setCommentsLikeCount,
  setLikedComment,
  handleShareClick,
  setExpanded,
  expanded,
  linkedDescription,
  parseDescriptionWithFormatting,
}) => {
  const navigate = useNavigate();
  const { userInfo } = useIds();
  const { enqueueSnackbar } = useSnackbar();

  const [commentsData, setCommentsData] = useState(comments);
  const [logoutDialogOpen, setLogoutDialogOpen] = useState(false);
  const [commentDialogue, setCommentDialogue] = useState(false);
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [totlePages, setTotlePages] = useState(0);
  const [isLoadingMore, setIsLoadingMore] = useState(false);
  const [loadMorePath, setLoadMorePath] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [slides, setSlides] = useState([]);
  const [loadMore, setLoadMore] = useState("api/feed/detail?page=1&limit=50");
  const observer = useRef();

  const lastBookElementRef = useCallback(
    (node) => {
      if (isLoadingMore) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && totlePages > pageNumber) {
          loadMoreData();
        }
      });
      if (node) observer.current.observe(node);
    },
    [isLoadingMore, totlePages, pageNumber, loadMorePath, observer]
  );

  const getFeedsDeteil = async () => {
    const result = await detail_feed_api(post._id);

    if (result.code === 200) {
      // setFeedDetail(result.feed);
      setLoadMorePath(result?.load_morse);
      setComments(result.feed_comment);

      setIsLoading(false);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
      setIsLoading(false);
    }
  };

  const isMobile = useMediaQuery("(max-width:600px)");
  const [companyModalOpen, setCompanyModalOpen] = useState(false);
  const [companyModalData, setCompanyModalData] = useState(null);
  const handleCompanyNameClick = () => {
    setCompanyModalData(post?.created_by);
    setCompanyModalOpen(true);
  };
  const handleCommentCompanyClick = (user) => {
    setCompanyModalData(user.commented_by._id);
    setCompanyModalOpen(true);
  };
  const handleCloseCompanyModal = () => {
    setCompanyModalOpen(false);
    setCompanyModalData(null);
  };
  const hadnlecommentdialogueOpen = () => {
    setCommentDialogue(true);
  };
  const handleCommentDelete = () => {
    setCommentDialogue(false);
    enqueueSnackbar("comment deleted successfully.", { variant: "success" });
  };
  const formatText = (text) => {
    if (!text) return "";

    text = text.replace(/(\S{10,})/g, "$1\u200B");

    const words = text.split(" ");
    return words
      .reduce((acc, word, index) => {
        if (index % 25 === 0 && index !== 0) {
          acc += "<br/>";
        }
        return acc + word + " ";
      }, "")
      .trim();
  };
  const loadMoreData = () => {
    setLoadMore(loadMorePath);
    setIsLoadingMore(true);
  };

  const handleDialogueOpen = () => {
    setLogoutDialogOpen(true);
  };

  const handleFeedEdit = () => {
    setOpenCreateModal(true);
  };

  const handleLogout = () => {
    setLogoutDialogOpen(false);
    enqueueSnackbar("post deleted successfully.", { variant: "success" });
  };

  const MENU_OPTIONS = [
    {
      label: "Edit",
      icon: "akar-icons:edit",
    },
    {
      label: "Delete",
      icon: "ant-design:delete-twotone",
      handleClick: handleDialogueOpen,
    },
  ];
  const handleEditComment = (comment, index) => {
    setIsEditing(true);
    setCommentText(comment.text);
  };
  const imageLinks = {
    docx: wordImage,
    mp3: audioImage,
    pdf: pdfImage,
    csv: csvImage,
    doc: docImage,
    xlsx: xlsxImage,
    xls: xlsxImage,
    other: otherImage,
  };

  const getCommentImage = (file) => {
    if (file.type === "file") {
      const ext = file.path.name.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return URL.createObjectURL(file.path);
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    } else {
      const ext = file.split(".").pop();
      if (
        ext == "jpg" ||
        ext == "JPG" ||
        ext == "png" ||
        ext == "webp" ||
        ext == "jpeg" ||
        ext == "JPEG" ||
        ext == "PNG"
      ) {
        return s3baseUri + file;
      } else if (imageLinks[ext]) {
        return imageLinks[ext];
      } else {
        return imageLinks.other;
      }
    }
  };

  useEffect(() => {
    let slide = [];
    if (post?.image?.length > 0) {
      slide = post.image.map((item) => {
        return {
          original: s3baseUri + item,
          thumbnail: s3baseUri + item,
        };
      });
    }
    setSlides(slide);
  }, [post]);

  useEffect(() => {
    if (open) {
      getFeedsDeteil();
    }
  }, [open]);

  useEffect(() => {
    if (comments?.liked_by?.length > 0) {
      const isLiked = comments.liked_by.some(
        (user) => user._id === userInfo?.user_id?._id
      );
      setLiked(isLiked);
    }
    if (comments.length > 0) {
      const likedComments = comments.reduce((acc, item, index) => {
        acc[index] = item.liked_by.some(
          (user) => user._id === userInfo?.user_id?._id
        );
        return acc;
      }, {});

      const likedCounts = comments.reduce((acc, item, index) => {
        acc[index] = item.liked_by.length;
        return acc;
      }, {});

      setCommentsLikeCount(likedCounts);
      setLikedComment(likedComments);
    }
  }, [comments]);

  const getImages = (data) => {
    let galleryArray = [];
    let galleryObject = {};
    data.map((gallery, index) => {
      galleryObject = {
        original: s3baseUri + gallery,
        thumbnail: s3baseUri + gallery,
      };
      galleryArray.push(galleryObject);
    });
    return galleryArray;
  };

  return (
    <>
      <CustomConfirmation
        open={logoutDialogOpen}
        setOpen={setLogoutDialogOpen}
        title={"Are you sure you want to delete this post?"}
        handleAgree={handleLogout}
      />
      <CustomConfirmation
        open={commentDialogue}
        setOpen={setCommentDialogue}
        title={"Are you sure you want to delete this comment?"}
        handleAgree={handleCommentDelete}
      />
      <Modal open={open} onClose={onClose} sx={{ overflow: "auto" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
            width: "100vw",
            height: "100vh",
            bgcolor: "black",
            overflow: "auto !important",
          }}
        >
          <IconButton
            onClick={onClose}
            sx={{
              position: "absolute",
              top: 10,
              left: 10,
              padding: "4px",
              backgroundColor: "white",
              zIndex: 10,
              "&:hover": {
                backgroundColor: "white",
              },
            }}
          >
            <CloseIcon style={{ fontSize: "18px" }} />
          </IconButton>
          {post?.feed_type === "image" && post.image ? (
            <div className="w-100 post-detail-image">
              <FeedImageSlider
                data={getImages(post.image)}
                selectedIndex={selectedImageIndex}
              />
            </div>
          ) : (
            ""
          )}
          {post?.feed_type === "video" && post?.video_url && (
            <Box
              sx={{
                flex: 2,
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                bgcolor: "black",
              }}
            >
              {!is_small_screen() ? (
                <div className="feed-video mx-5">
                  <ReactVideoPlayer url={post?.video_url} playingVideo={true} />
                </div>
              ) : (
                <div className="mx-3 my-3">
                  <ReactVideoPlayer url={post?.video_url} playingVideo={true} />
                </div>
              )}
            </Box>
          )}
          {post?.feed_type === "document" && post?.image?.length > 0 && (
            <div
              className="feed-image document_img mt-3 d-flex w-100 text-center"
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {post.image.map((item, index) => (
                <a
                  key={index}
                  target="_blank"
                  rel="noopener noreferrer"
                  href={s3baseUri + item}
                  className="pointer"
                  style={{
                    display: "block",
                    marginBottom: "10px",
                    color: "blue",
                  }}
                >
                  <img className="img-fluid" src={getCommentImage(item)} />{" "}
                </a>
              ))}
            </div>
          )}

          <Box
            className={
              post.feed_type == "general" || post.feed_type == "document"
                ? "mx-auto widht_contoral "
                : "bg-white"
            }
            sx={{
              marginTop: isMobile ? "40px " : "",
              position: "sticky",
              top: 0,
              zIndex: 10,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              padding: 2,
              minHeight: "100%",
              overflow: "auto !important",
              width: {
                xs:
                  post?.feed_type === "image" ||
                  post?.feed_type === "video" ||
                  post?.feed_type === "document"
                    ? "100%"
                    : "70%", // Mobile: 100% for image/video/document, 70% for other types
                sm: "500px", // No change for tablet and above
              },
            }}
          >
            <Box
              display="flex"
              alignItems="center"
              justifyContent="space-between"
            >
              <Box display="flex" alignItems="center" width="100%">
                <Avatar
                  onClick={handleCompanyNameClick}
                  src={s3baseUri + post?.created_by?.profile_image}
                  sx={{ width: 45, height: 45, mr: 1, cursor: "pointer" }}
                />
                <Box width="100%">
                  <Box
                    display="flex"
                    alignItems="center"
                    justifyContent="space-between"
                  >
                    <Typography
                      variant="h6"
                      fontWeight="bold"
                      sx={{
                        fontSize: "14px",
                        cursor: "pointer",
                        "&:hover": {
                          textDecoration: "underline",
                          color: "#000080",
                        },
                      }}
                      onClick={handleCompanyNameClick}
                    >
                      {post?.created_by?.company_name}
                    </Typography>
                    {userInfo?.user_id?._id ===
                      post?.created_by?.user_id?._id && (
                      <CustomPopover menu={handleMenu(post)} data={comments} />
                    )}
                  </Box>
                  <Typography
                    sx={{
                      fontSize: "12px",
                      lineHeight: 0.6,
                      letterSpacing: "0rem !important",
                    }}
                    variant="caption"
                    color="textSecondary"
                  >
                    {moment(post.published_time).format(
                      "DD MMM YYYY [at] hh:mm A"
                    )}
                  </Typography>
                </Box>
              </Box>
            </Box>
            <div className="col-12">
              {linkInDescription ? (
                <>
                  <Typography
                    variant="body1"
                    mt={1}
                    sx={{
                      fontSize: "14px",
                      marginRight: "2px",
                      display: "-webkit-box",
                      WebkitLineClamp: expanded ? "unset" : 3, // Show 3 lines when collapsed
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    className="pointer"
                  >
                    {parseDescriptionWithLink(post.description)}
                  </Typography>
                  {post?.description?.length > 150 && ( // Only show toggle if description is long
                    <Typography
                      variant="body2"
                      color="primary"
                      sx={{
                        fontSize: "12px",
                        cursor: "pointer",
                        fontWeight: 500,
                        mt: 0.5,
                        textDecoration: "underline", // Add this line
                      }}
                      onClick={() => setExpanded(!expanded)}
                    >
                      {expanded ? "Read Less" : "Read More"}
                    </Typography>
                  )}
                  {post?.is_link_preview && (
                    <PreviewPostCard text={linkInDescription} />
                  )}
                </>
              ) : (
                <>
                  <Typography
                    variant="body1"
                    mt={1}
                    sx={{
                      fontSize: "14px",
                      display: "-webkit-box",
                      WebkitLineClamp: expanded ? "unset" : 3,
                      WebkitBoxOrient: "vertical",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                    className="pointer"
                  >
                    {post?.description}
                  </Typography>
                  {post?.description?.length > 150 && (
                    <Typography
                      variant="body2"
                      color="primary"
                      sx={{
                        fontSize: "12px",
                        cursor: "pointer",
                        fontWeight: 500,
                        mt: 0.5,
                        textDecoration: "underline", // Add this line
                      }}
                      onClick={() => setExpanded(!expanded)}
                    >
                      {expanded ? "Read Less" : "Read More"}
                    </Typography>
                  )}
                </>
              )}
            </div>
            <Typography
              sx={{ color: "#00000054", fontSize: "13px", marginLeft: "5px" }}
              variant="body2"
              color="textSecondary"
              mt={2}
            >
              {likeCount} {likeCount > 0 ? "Likes" : "Like"}{" "}
              {/* {post.comment_count}
              Comments */}
              {commentCount} Comments
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-around",
                alignItems: "center",
                py: "5px",
                borderTop: "1px solid #00000054",
                borderBottom: "1px solid #00000054",
              }}
            >
              {/* Like Section */}
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  cursor: "pointer",
                }}
                onClick={() => {
                  handleLike();
                }}
              >
                <IconButton
                  sx={{ padding: "0px" }}
                  disabled={userInfo?.type === 1}
                >
                  {liked ? (
                    <ThumbUpIcon sx={{ color: "#0a0eae", fontSize: "18px" }} />
                  ) : (
                    <ThumbUpAltOutlinedIcon
                      sx={{ fontSize: "18px", color: "#888" }}
                    />
                  )}
                  <Typography sx={{ marginLeft: "4px", color: "black" }}>
                    Like
                  </Typography>
                </IconButton>
              </Box>

              {/* Comment Section */}
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  cursor: userInfo?.type === 1 ? "not-allowed" : "pointer",
                  opacity: userInfo?.type === 1 ? 0.5 : 1,
                }}
                onClick={() => {
                  if (userInfo?.type !== 1) {
                    // Trigger comment box or any other logic
                    console.log("Comment clicked");
                  }
                }}
              >
                <ChatBubbleOutlineOutlinedIcon
                  sx={{ mr: 1, fontSize: "18px", color: "gray" }}
                />
                <Typography>Comment</Typography>
              </Box>
              <Tooltip
                title={!post.description ? "Description required to share" : ""}
                placement="top"
                disableHoverListener={!!post.description}
                arrow
              >
                <span>
                  <Box
                    display="flex"
                    alignItems="center"
                    sx={{
                      cursor: "pointer",
                    }}
                    onClick={
                      !post.description
                        ? () => {}
                        : () => handleShareClick(post)
                    }
                  >
                    <ShareIcon
                      sx={{ mr: 1, fontSize: "18px", color: "gray" }}
                    />
                    <Typography>Share</Typography>
                  </Box>
                </span>
              </Tooltip>
            </Box>

            <Box
              sx={{ overflowY: "auto", flex: 1, mt: 2, px: { xs: 1, sm: 2 } }}
            >
              {comments && comments.length > 0 && (
                <Box sx={{ borderRadius: 2 }}>
                  {comments.map((comment, index) => (
                    <Box
                      key={index}
                      sx={{ borderRadius: 2, paddingBottom: "0px" }}
                      bgcolor="#F1F1F1"
                      p={1}
                      mb={1}
                    >
                      <div className="poster-name-image d-flex w-100 single-comment-card">
                        <Avatar
                          src={s3baseUri + comment?.commented_by?.profile_image}
                          sx={{
                            width: 40,
                            height: 40,
                            mr: 1,
                            cursor: "pointer",
                          }}
                          onClick={() => handleCommentCompanyClick(comment)}
                        />
                        <div className="w-100">
                          <div
                            className="text-start set-title-width poster-name ps-1 w-100 d-flex"
                            style={{
                              justifyContent: "space-between",
                              display: "flex",
                            }}
                          >
                            <Typography
                              variant="h6"
                              fontWeight="bold"
                              sx={{ fontSize: "14px", cursor: "pointer" }}
                              onClick={() => handleCommentCompanyClick(comment)}
                            >
                              {htmlDecode(comment?.commented_by?.name)}
                            </Typography>
                            <div className="popOver d-flex mt-1">
                              <Typography
                                className="date-color float-end "
                                sx={{
                                  fontSize: "12px",
                                  lineHeight: 1,
                                  marginTop: "3px",
                                }}
                                color="textSecondary"
                              >
                                {moment(comment?.createdAt).format(
                                  "DD MMM YYYY [at] hh:mm A"
                                )}
                              </Typography>
                              {userInfo?.user_id?._id ===
                                comment?.commented_by?._id && (
                                <CustomPopover
                                  menu={handleMenucomments(comment)}
                                  data={comment}
                                />
                              )}
                            </div>
                          </div>
                          <div className="post-description  ps-1">
                            <Typography
                              variant="body2"
                              color="textSecondary"
                              sx={{
                                fontSize: "12px",
                                lineHeight: 1.2,
                                whiteSpace: "pre-line",
                                wordBreak: "break-word",
                              }}
                              dangerouslySetInnerHTML={{
                                __html: htmlDecode(comment?.text),
                              }}
                            ></Typography>
                            {comment?.comment_image && (
                              <Box>
                                <img
                                  onClick={() =>
                                    window.open(
                                      s3baseUri + comment.comment_image,
                                      "_blank"
                                    )
                                  }
                                  src={s3baseUri + comment.comment_image}
                                  alt="Uploaded Comment"
                                  style={{
                                    lineHeight: "0px",
                                    height: "80px",
                                    width: "80px",
                                    borderRadius: "5px",
                                    cursor: "pointer",
                                  }}
                                />
                              </Box>
                            )}
                            <button
                              onClick={() => handleLikeComment(comment, index)}
                              style={{
                                border: "none",
                                background: "none",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                paddingLeft: "0px",
                                marginTop: "5px",
                              }}
                            >
                              {likedComment[index] ? (
                                <ThumbUpIcon
                                  style={{ fontSize: "16px", color: "#000080" }}
                                />
                              ) : (
                                <ThumbUpAltOutlinedIcon
                                  style={{
                                    fontSize: "16px",
                                    color: "#00000054",
                                  }}
                                />
                              )}
                              <span
                                style={{
                                  marginLeft: 5,
                                  color: "#000000c0",
                                  fontSize: "12px",
                                }}
                              >
                                {commentsLikeCount[index]} Like
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </Box>
                  ))}
                </Box>
              )}
            </Box>

            <form onSubmit={handleCommentSubmit}>
              <Box
                display="flex"
                alignItems="center"
                sx={{
                  flexDirection: { xs: "column", sm: "row" },
                }}
              >
                <TextField
                  fullWidth
                  label={
                    isEditing ? "Edit your comment..." : "Write a comment..."
                  }
                  multiline
                  rows={2}
                  value={commentText}
                  onChange={(e) => setCommentText(e.target.value)}
                  disabled={userInfo?.type === 1}
                  sx={{
                    bgcolor: "white",
                    borderRadius: "5px",
                    flexGrow: 1,
                    minWidth: { xs: "100%", sm: "80%" },
                    opacity: userInfo?.type === 1 ? 0.6 : 1,
                    cursor: userInfo?.type === 1 ? "not-allowed" : "text",
                    "& .MuiOutlinedInput-root": {
                      paddingTop: "5px",
                      paddingBottom: "4px",
                    },
                    "& .MuiOutlinedInput-input": {
                      padding: "4px 8px",
                    },
                  }}
                />
              </Box>

              <Box
                mt={1}
                display="flex"
                justifyContent="space-between"
                sx={{
                  width: "100%",
                  alignItems: "center",
                }}
              >
                {/* File upload + preview */}
                <div className="d-flex">
                  {!openCreateModal && (
                    <>
                      <IconButton
                        component="label"
                        disabled={userInfo?.type === 1}
                      >
                        <input
                          type="file"
                          id="imageInput"
                          style={{ display: "none" }}
                          accept="image/*"
                          onChange={handleImageUpload}
                          disabled={userInfo?.type === 1}
                        />
                        {!preview && (
                          <AddPhotoAlternateOutlinedIcon
                            sx={{
                              color: "#daa520",
                              opacity: userInfo?.type === 1 ? 0.5 : 1,
                            }}
                          />
                        )}
                      </IconButton>

                      {preview && (
                        <div
                          style={{
                            padding: "4px",
                            borderRadius: "5px",
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                            maxWidth: "fit-content",
                            position: "relative",
                            border: "1px solid #ddd",
                            background: "#fff",
                            opacity: userInfo?.type === 1 ? 0.5 : 1,
                          }}
                        >
                          <span
                            onClick={() =>
                              userInfo?.type !== 1 && setPreview(null)
                            }
                            style={{
                              cursor:
                                userInfo?.type === 1
                                  ? "not-allowed"
                                  : "pointer",
                              background: "red",
                              color: "white",
                              borderRadius: "50%",
                              width: "15px",
                              height: "15px",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              fontSize: "10px",
                              fontWeight: "bold",
                              position: "absolute",
                              top: "-8px",
                              right: "-8px",
                              zIndex: 2,
                              boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                            }}
                          >
                            ✖
                          </span>
                          <img
                            src={
                              typeof preview === "string" &&
                              preview.startsWith("blob:")
                                ? preview
                                : s3baseUri + preview
                            }
                            alt="Preview"
                            style={{
                              width: "50px",
                              height: "50px",
                              borderRadius: "5px",
                              objectFit: "cover",
                              position: "relative",
                            }}
                          />
                        </div>
                      )}
                    </>
                  )}
                </div>

                {/* Emoji Picker (Optional block if type === 1) */}
                {emojiPickerVisible && userInfo?.type !== 1 && (
                  <Box
                    sx={{
                      position: "absolute",
                      left: isMobile ? "" : "-360px",
                      bottom: "60px",
                    }}
                  >
                    <Picker data={data} onEmojiSelect={handleEmojiClick} />
                  </Box>
                )}

                {/* Submit Button */}
                <button
                  className="small-button-cotain-post"
                  type="submit"
                  disabled={isLoadingCom || userInfo?.type === 1}
                  style={{
                    width: "100%",
                    maxWidth: "150px",
                    marginTop: { xs: "8px", sm: "0px" },
                    opacity: isLoadingCom || userInfo?.type === 1 ? 0.6 : 1,
                    cursor:
                      isLoadingCom || userInfo?.type === 1
                        ? "not-allowed"
                        : "pointer",
                    pointerEvents:
                      isLoadingCom || userInfo?.type === 1 ? "none" : "auto",
                  }}
                >
                  {isLoadingCom
                    ? isEditing
                      ? "Updating..."
                      : "Posting..."
                    : isEditing
                    ? "Update"
                    : "Post Comment"}
                </button>
              </Box>
            </form>
          </Box>
        </Box>
      </Modal>
      {/* Company Profile Modal (shared for post creator and comment user) */}
      <Modal
        open={companyModalOpen}
        onClose={handleCloseCompanyModal}
        aria-labelledby="company-profile-modal"
        aria-describedby="company-profile-details"
        sx={{
          outline: "none !important",
          boxShadow: "none",
          "& .MuiBackdrop-root": { outline: "none !important" },
          "& .MuiBox-root": { outline: "none !important" },
          "&:focus": {
            outline: "none !important",
            boxShadow: "none",
            border: "none",
          },
          "&:focus-visible": {
            outline: "none !important",
            boxShadow: "none",
            border: "none",
          },
        }}
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: { xs: "99vw", sm: 1400, md: 1600, lg: 1800 },
            maxWidth: 1200,
            height: "auto",
            maxHeight: "97vh",
            bgcolor: "#fff",
            borderRadius: 3,
            boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
            overflow: "hidden",
            p: 0,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Fixed header */}
          <Box
            sx={{
              position: "sticky",
              top: 0,
              zIndex: 10,
              background: "linear-gradient(90deg, #000080 0%, #3a3a90 100%)",
              color: "white",
              px: 4,
              py: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              boxShadow: "0 2px 12px rgba(0,0,0,0.10)",
              minHeight: 56,
            }}
          >
            <Typography
              variant="h6"
              fontWeight={700}
              sx={{ letterSpacing: 1, fontSize: 20 }}
            >
              Company Profile
            </Typography>
            <IconButton onClick={handleCloseCompanyModal}>
              <CloseIcon style={{ color: "#fff" }} />
            </IconButton>
          </Box>
          {/* Scrollable content below header, no horizontal scroll */}
          <Box
            sx={{
              flex: 1,
              minHeight: 0,
              overflowY: "auto",
              overflowX: "hidden",
              p: 0,
            }}
          >
            <Box className="container-fluid" sx={{ p: 2 }}>
              <Box className="row">
                <Box className="col-12 mt-3">
                  <Box
                    className="card shadow-md p-4"
                    sx={{ borderRadius: 3, mb: 0 }}
                  >
                    <Box className="row g-4">
                      <Box className="col-md-6">
                        <Box className="d-flex">
                          <Box className="heading-main container mb-4 ">
                            <Typography
                              variant="h5"
                              fontWeight="bold"
                              className="fw-bold mb-2 "
                            >
                              {companyModalData?.company_name ||
                                companyModalData?.name ||
                                "N/A"}
                            </Typography>
                          </Box>
                        </Box>
                        <Divider />
                        <Box
                          className="info-section detail-page-text"
                          sx={{
                            wordWrap: "break-word",
                            overflow: "hidden",
                            maxWidth: "100%",
                          }}
                        >
                          <p>
                            <strong>Company Name</strong>{" "}
                            <span className="text-muted ms-4">
                              {companyModalData?.company_name ||
                                companyModalData?.name ||
                                "N/A"}
                            </span>
                          </p>
                          <Divider />
                          <p>
                            <strong>sector</strong>{" "}
                            <span className="text-muted ms-4">
                              {companyModalData?.sector || "N/A"}
                            </span>
                          </p>
                          <Divider />
                          <p>
                            <strong>Location</strong>{" "}
                            <span className="text-muted">
                              {companyModalData?.location || "N/A"}
                            </span>
                          </p>
                          <Divider />
                          <p>
                            <strong>Website</strong>{" "}
                            {companyModalData?.website ? (
                              <a
                                href={companyModalData?.website}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-primary ms-4 pointer"
                                style={{ wordBreak: "break-word" }}
                              >
                                {companyModalData?.website}
                              </a>
                            ) : (
                              <span>no data</span>
                            )}
                          </p>
                          <Divider />
                          <p>
                            <strong>Contact Number</strong>{" "}
                            <span className="text-muted ms-4">
                              {companyModalData?.contact_number || "N/A"}
                            </span>
                          </p>
                          <Divider />
                          <p>
                            <strong>Email</strong>{" "}
                            <span className="text-muted ms-4">
                              {companyModalData?.email ||
                                companyModalData?.user_id?.email ||
                                "N/A"}
                            </span>
                          </p>
                          <Divider />
                          {/* Social Links if exist */}
                          {companyModalData?.social_links && (
                            <Box sx={{ mb: 2 }}>
                              <Box
                                sx={{
                                  display: "flex",
                                  gap: 2,
                                  alignItems: "center",
                                  flexWrap: "wrap",
                                  marginTop: "20px",
                                  marginLeft: "10px",
                                }}
                              >
                                {companyModalData.social_links.facebook && (
                                  <a
                                    href={
                                      companyModalData.social_links.facebook
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaFacebook size={22} color="#4267B2" />
                                  </a>
                                )}
                                {companyModalData.social_links.instagram && (
                                  <a
                                    href={
                                      companyModalData.social_links.instagram
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaInstagram size={22} color="#E1306C" />
                                  </a>
                                )}
                                {companyModalData.social_links.linkedin && (
                                  <a
                                    href={
                                      companyModalData.social_links.linkedin
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaLinkedin size={22} color="#0077B5" />
                                  </a>
                                )}
                                {companyModalData.social_links.twitter && (
                                  <a
                                    href={companyModalData.social_links.twitter}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaTwitter size={22} color="#1DA1F2" />
                                  </a>
                                )}
                                {companyModalData.social_links.youtube && (
                                  <a
                                    href={companyModalData.social_links.youtube}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <FaYoutube size={22} color="#FF0000" />
                                  </a>
                                )}
                              </Box>
                            </Box>
                          )}
                        </Box>
                      </Box>
                      <Box className="col-lg-6 col-md-6 col-sm-12 d-flex justify-content-center align-items-center">
                        {companyModalData?.profile_image ? (
                          <img
                            src={s3baseUri + companyModalData?.profile_image}
                            alt={
                              companyModalData?.company_name ||
                              companyModalData?.name
                            }
                            className="rounded-3 shadow-sm img-fluid"
                            style={{ maxHeight: 260, objectFit: "cover" }}
                          />
                        ) : (
                          <RecordNoImage title="No Image Available" />
                        )}
                      </Box>
                    </Box>
                    {companyModalData?.about && (
                      <Box
                        className="card shadow-md p-4 mt-3 mb-4 about-content"
                        sx={{ borderRadius: 3 }}
                      >
                        <Typography
                          variant="h5"
                          fontWeight="bold"
                          className="fw-bold mb-4 ps-2"
                        >
                          About
                        </Typography>
                        <Typography
                          className="ps-2 ckeditor-content"
                          sx={{ color: "#444", fontSize: 16 }}
                          component="div"
                          dangerouslySetInnerHTML={{
                            __html: companyModalData?.about,
                          }}
                        />
                      </Box>
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      </Modal>
    </>
  );
};

export default PostDetailPopup;
